import { useState, useEffect } from 'react';
import { useAuth } from '../services/authentication/authContext';
import { isImpersonating } from '../stores/appImpersonationStore';
import { hasFreeSubscription } from '../services/accessManagement/accessManagement';

interface SubscriptionStatus {
  isActive: boolean;
  loading: boolean;
}

export function useSubscription(): SubscriptionStatus {
  const { backendUser, accountSettings, loading: authLoading, user } = useAuth();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Only stop loading when auth is done AND we have backendUser (or we know there's no user)
    if (!authLoading) {
      if (!user || backendUser !== null) {
        setLoading(false);
      }
    }
  }, [authLoading, user, backendUser]);


  // Check if account has free subscription setting
  const isFreeSubscriptionUser = hasFreeSubscription(backendUser, accountSettings);

  const checkSubscription = process.env.REACT_APP_CHECK_SUBSCRIPTION === 'true';
  const trustedImpersonation = backendUser?.is_super_admin_identity && isImpersonating();

  // Override subscription status for accounts with free subscription setting
  const isActive = isFreeSubscriptionUser || (!checkSubscription && (!backendUser?.managed_customer || trustedImpersonation)) || backendUser?.subscription_status === 'ACTIVE';

  return {
    isActive,
    loading,
  };
}
